import SoftwareInfo from './SoftwareInfo';

export default SoftwareInfo;
